import { render } from "./PageCreateBot.vue?vue&type=template&id=3193aef4&scoped=true"
import script from "./PageCreateBot.vue?vue&type=script&lang=js"
export * from "./PageCreateBot.vue?vue&type=script&lang=js"

import "./PageCreateBot.vue?vue&type=style&index=0&id=3193aef4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3193aef4"]])

export default __exports__